var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIconforPfizerOptedIn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 90,
    viewBox: "0 0 95 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43.5,
    stroke: "#734BD1",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 16,
    r: 14.5,
    fill: "#4CA231",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.375 66.625V78H40.2266V66.625H42.375ZM46.5625 71.3516V78H44.5V69.5469H46.4375L46.5625 71.3516ZM46.2344 73.4688H45.625C45.6302 72.8542 45.7135 72.2969 45.875 71.7969C46.0365 71.2969 46.263 70.8672 46.5547 70.5078C46.8516 70.1484 47.2031 69.8724 47.6094 69.6797C48.0156 69.487 48.4688 69.3906 48.9688 69.3906C49.375 69.3906 49.7422 69.4479 50.0703 69.5625C50.3984 69.6771 50.6797 69.8594 50.9141 70.1094C51.1536 70.3594 51.3359 70.6875 51.4609 71.0938C51.5911 71.4948 51.6562 71.9896 51.6562 72.5781V78H49.5781V72.5625C49.5781 72.1771 49.5208 71.8724 49.4062 71.6484C49.2969 71.4245 49.1354 71.2656 48.9219 71.1719C48.7135 71.0781 48.4557 71.0312 48.1484 71.0312C47.8307 71.0312 47.5521 71.0964 47.3125 71.2266C47.0781 71.3516 46.8802 71.526 46.7188 71.75C46.5625 71.974 46.4427 72.2318 46.3594 72.5234C46.276 72.8151 46.2344 73.1302 46.2344 73.4688Z",
    fill: "#734BD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41.3C51.0751 41.3 56 35.6364 56 28.65C56 21.6636 51.0751 16 45 16C38.9249 16 34 21.6636 34 28.65C34 35.6364 38.9249 41.3 45 41.3Z",
    fill: "#734BD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7816 45.0987L53.7941 41.4688C53.1848 41.1916 52.4884 41.2659 51.9384 41.6637L50.1883 42.9352C47.1344 45.155 43.1397 45.1208 40.1191 42.8509L38.5616 41.6797C38.0172 41.2719 37.3208 41.1856 36.7078 41.4547L28.298 45.1248C26.1664 46.0549 24.6052 48.0778 24.1348 50.5185L23.0644 56.0808C22.6755 58.1017 24.0978 60 26.0016 60H63.9984C65.9022 60 67.3245 58.1017 66.9356 56.0808L65.8522 50.4522C65.3911 48.0496 63.8669 46.0489 61.7816 45.0987Z",
    fill: "#734BD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIconforPfizerOptedIn1);
export default __webpack_public_path__ + "static/media/Staff Icon for Pfizer - Opted In_1.a207407e1003856f24ecc05d279f2ace.svg";
export { ForwardRef as ReactComponent };